import React from "react";

const PrimaryChipButton = ({
  title,
  icon,
  handleClick,
  disabled,
  minWidth,
  marginLeft,
  showIcon,
  height,
}) => {
  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className="btn btnOutline"
      style={{ minWidth: minWidth, marginLeft: marginLeft, height: height, backgroundColor:'#fff', padding:'7px 12px 6px 12px' }}
    >
      {showIcon ? (
        <>
          <img src={icon} alt="" /> {title}
        </>
      ) : (
        title
      )}
    </button>
  );
};

export default PrimaryChipButton;
